'use client';
import * as React from 'react';
import {
  Unstable_NumberInput as BaseNumberInput,
  NumberInputProps,
} from '@mui/base/Unstable_NumberInput';
import { styled } from '@mui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from '@peerless/ui-assets/icons';
import { palette } from '@peerless/ui-assets/palette';

interface Props {
  value?: number | null;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange?(
    event: React.FocusEvent<HTMLInputElement> | React.PointerEvent | React.KeyboardEvent,
    value?: number | null
  ): void;
}

export const QuantityInput: React.FC<Props> = props => {
  return <NumberInput aria-label="Quantity Input" min={0} max={99} {...props} />;
};

const NumberInput = (props: NumberInputProps & { ref?: React.Ref<HTMLDivElement> }) => {
  const { ref, ...otherProps } = props;
  return (
    <BaseNumberInput
      slots={{
        root: StyledInputRoot,
        input: StyledInput,
        incrementButton: StyledButton,
        decrementButton: StyledButton,
      }}
      slotProps={{
        incrementButton: {
          children: <FontAwesomeIcon icon={icons.plus} />,
          className: 'increment',
        },
        decrementButton: {
          children: <FontAwesomeIcon icon={icons.minus} />,
        },
        input: { disabled: true },
      }}
      {...otherProps}
      ref={ref}
    />
  );
};

const StyledInputRoot = styled('div')(
  ({ theme }) => `
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`
);

const StyledInput = styled('input')`
  background: ${palette.transparent.white};
  border: 1.5px solid;
  padding: 4px 12px;
  height: 2rem;
  outline: 0;
  min-width: 0;
  width: 4rem;
  text-align: center;
  &:focus-visible {
    outline: 0;
  }
`;

const StyledButton = styled('button')`
  border: solid 1.5px ${palette.secondary.dark};
  width: 2rem;
  height: 2rem;
  display: flex;
  background: ${palette.secondary.dark};
  color: ${palette.primary.contrastText};
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    cursor: pointer;
    background: ${palette.primary.main};
    border-color: ${palette.primary.main};
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }
`;
